import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import BackToTop from './BackToTop';

// Shared default hero artwork until each product gets bespoke art.
// TODO: swap per-product hero image from props when the user supplies them.
const DEFAULT_HERO_IMAGE = 'https://customer-assets.emergentagent.com/job_3f9e40e3-cca9-4507-83e7-20ced098354a/artifacts/69qn1rnj_ABSTRACT%20DESIGN.png';

export const PRODUCT_CONTAINERS = [
  { id: 'pos-card-machines',     title: 'POS Card Machines',     link: '/products/pos-card-machines' },
  { id: 'epos-and-mini',         title: 'EPOS & EPOS Mini',      link: '/products/epos-and-mini' },
  { id: 'softpos-and-mpos',      title: 'SoftPOS & MPOS',        link: '/products/softpos-and-mpos' },
  { id: 'ecommerce-solutions',   title: 'eCommerce Solutions',   link: '/products/ecommerce-solutions' },
  { id: 'transaction-reporting', title: 'Transaction Reporting', link: '/products/transaction-reporting' },
];

const ProductPageLayout = ({
  currentId,
  title,
  subtitle,
  eyebrow,
  heroImage = DEFAULT_HERO_IMAGE,
  customHero = null,
  bodyBgClassName = 'bg-gradient-to-b from-gray-50 to-white',
  mainTestId = 'product-page',
  children,
}) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col" data-testid={mainTestId}>
      <Header />
      <div className="h-20" />

      {/* Hero — custom override OR default full-bleed bg-image hero */}
      {customHero ? (
        customHero
      ) : (
        <section
          className="relative bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${heroImage})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-[#0a1929]/90 via-[#0a1929]/80 to-[#163a5f]/85" />
          <div className="relative z-10 max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-14">
            <button
              onClick={() => navigate('/products')}
              className="flex items-center gap-2 text-white/85 hover:text-white font-medium mb-8 transition-colors duration-200"
              data-testid="product-back-button"
            >
              <ArrowLeft size={18} />
              Back to Products
            </button>

            <div className="max-w-4xl">
              {eyebrow && (
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#ef5b25]/20 border border-[#ef5b25]/40 text-[#ffcba6] text-[11px] font-bold uppercase tracking-[0.15em] mb-5">
                  {eyebrow}
                </div>
              )}
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight" data-testid="product-title">
                {title}
              </h1>
              {subtitle && (
                <p className="text-lg sm:text-xl text-white font-semibold leading-relaxed max-w-3xl">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
        </section>
      )}

      {/* Content area on light background */}
      <section className={`flex-1 ${bodyBgClassName} pt-10 pb-14`}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          {children}
        </div>
      </section>

      <Footer />
      <BackToTop />
    </div>
  );
};

export default ProductPageLayout;
